import { render, staticRenderFns } from "./SortTh.vue?vue&type=template&id=2bcf0cce&"
import script from "./SortTh.vue?vue&type=script&lang=ts&"
export * from "./SortTh.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports